module.exports = __webpack_public_path__ + "static/media/me3_SSO_Envelope.6a4b4266.svg";